export default __webpack_public_path__ + "static/media/262.1203fc94.gif";